var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInviteUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7917 18.5C4.625 18.5 4.625 21.2596 4.625 24.6667V26.2083C4.625 30.4633 4.625 33.9167 12.3333 33.9167H24.6667C30.8333 33.9167 32.375 30.4633 32.375 26.2083V24.6667C32.375 21.2596 32.375 18.5 26.2083 18.5C24.6667 18.5 24.235 18.8238 23.4333 19.425L21.8608 21.09C20.0417 23.0325 16.9583 23.0325 15.1238 21.09L13.5667 19.425C12.765 18.8238 12.3333 18.5 10.7917 18.5Z",
    stroke: "#662D91",
    strokeWidth: 2.3125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2917 18.5V9.25001C29.2917 5.84293 29.2917 3.08334 23.125 3.08334H13.875C7.70837 3.08334 7.70837 5.84293 7.70837 9.25001V18.5",
    stroke: "#662D91",
    strokeWidth: 2.3125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.2646 14.2296H21.3984",
    stroke: "#662D91",
    strokeWidth: 2.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.985 9.60461H22.6933",
    stroke: "#662D91",
    strokeWidth: 2.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteUser);
export default __webpack_public_path__ + "static/media/invite_user.765b5b5b2441d0548e9ac901785e66f8.svg";
export { ForwardRef as ReactComponent };